'use strict';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
const API = require('../../APIs/configApi');
// const axios = require('axios');
const expirationTime = 3300000;

const getNewToken = async function (context) {
  try {
    const token = await getAuth().currentUser.getIdToken(true);
    const expirationDate = new Date().getTime() + expirationTime;
    localStorage.setItem('accesstoken', token);
    localStorage.setItem('tokenExpiration', expirationDate);
    timer = setTimeout(() => {
      context.commit('SET_AUTOLOGOUT_MIDW_AUTH', true);
    }, expirationTime);
    context.commit('SET_TOKEN_MIDW_AUTH', {
      token: token,
      autologout: false,
    });
    return true;
  } catch (error) {
    return false;
  }
};
const tryLoginMiddlewareAuth = function (context) {
  const token = localStorage.getItem('accesstoken');
  const userId = localStorage.getItem('userId');
  const email = localStorage.getItem('email');
  const displayName = localStorage.getItem('displayName');
  const tokenExpiration = localStorage.getItem('tokenExpiration');
  let trustPC = localStorage.getItem('trustPC') || null;
  if (typeof trustPC === 'string') {
    trustPC = trustPC === 'true';
  }
  if (typeof tokenExpiration === 'undefined' || tokenExpiration === null) {
    return 0;
  }
  const expiresIn = +tokenExpiration - new Date().getTime();
  if (expiresIn < 1000) {
    context.commit('RESET_LOGIN_DATA_MIDW_AUTH');
    return 1;
  }
  timer = setTimeout(() => {
    context.commit('SET_AUTOLOGOUT_MIDW_AUTH', true);
  }, expiresIn);

  context.commit('SET_FULL_LOGIN_DATA_MIDW_AUTH', {
    displayName: displayName,
    userId: userId,
    email: email,
    token: token,
    autologout: false,
    trustPC: trustPC,
  });
  return 2;
};

let timer;
export default {
  async loginMiddlewareAuth(context, payload) {
    const response = await signInWithEmailAndPassword(
      getAuth(),
      payload.email,
      payload.password,
    );
    if (!response.user.emailVerified) {
      return false;
    }
    localStorage.setItem(
      'displayName',
      response.user.displayName || 'ZP User',
    );
    localStorage.setItem('email', response.user.email);
    localStorage.setItem('userId', response.user.uid);
    localStorage.setItem('trustPC', payload.trustPC);
    context.commit('SET_LOGIN_DATA_MIDW_AUTH', {
      displayName: response.user.displayName || 'ZP User',
      userId: response.user.uid,
      email: response.user.email,
      trustPC: payload.trustPC,
    });
    return getNewToken(context);
  },
  async updateTokenMiddlewareAuth(context) {
    return getNewToken(context);
  },
  async resendVerifMiddlewareAuth(context, payload) {
    const responseData = await API.resendVerification(payload);
    return responseData.success;
  },

	async readBasicUserDataMiddlewareAuth(context, payload) {
		const responseData = await API.readBasicUserData(payload);
		if (responseData.success) {
			context.commit('SET_BASIC_USER_DATA_MIDW_AUTH', responseData.data);
		}
		return responseData.success;
	},
	async readUserFullNameMiddlewareAuth(context, payload) {
		const responseData = await API.readUserFullName(payload);
		if (responseData.success) {
			context.commit('SET_USER_NAME_MIDW_AUTH', responseData.data);
		}
		return responseData.success;
	},
	async retrieveBasicUserDataMiddlewareAuth(context, payload) {
		const responseData = await API.readBasicUserData(payload);
		return responseData;
	},
	tryLoginMiddlewareAuth,
	async signupMiddlewareAuth(context, payload) {
		try {
			const responseData = await API.signup(payload);
			return responseData;
		}
		catch {
			return false;
		}
	},
	async fetchTokenAuth(context, payload){
		try {
			const responseData = await API.getOauth(payload);
			sessionStorage.setItem('zohoAccessToken', responseData.data.newZohoAccessToken);
			sessionStorage.setItem('zohoTokenExpirationTime', responseData.data.newZohoTokenExpirationTime);
			return responseData.success
		}
		catch {
			return false;
		}
	},

  async resetPasswordMiddlewareAuth(context, payload) {
    const responseData = await API.resetPassword(payload);
    return responseData.success;
  },

  async logoutMiddlewareAuth(context) {
    localStorage.removeItem('accesstoken');
    localStorage.removeItem('userId');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('displayName');
    localStorage.removeItem('email');
    localStorage.removeItem('trustPC');
    clearTimeout(timer);
    await getAuth().signOut();
    context.commit('RESET_LOGIN_DATA_MIDW_AUTH');
    return true;
  },

  setAutoLogoutMiddlewareAuth(context, value) {
    context.commit('SET_AUTOLOGOUT_MIDW_AUTH', value);
    return true;
  },
};
